import * as Rx from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Collections } from '../collections.model';
import { BackendResponse, StoreBackend } from './backend';
import { RequestStatus } from './request-status-handler.service';
import { Reference } from './store.model';

export class DatastoreDocument<K extends keyof Collections> {
  constructor(
    private ref$: Rx.Observable<
      Reference<K> & { readonly path: { readonly ids: [string] } }
    >, // The path needs to have a single entry in `ids`.
    private storeBackend: StoreBackend,
    public status$: Rx.Observable<RequestStatus>,
    private valueChanges$: Rx.Observable<Collections[K]>,
  ) {}

  valueChanges(): Rx.Observable<Collections[K]> {
    return this.valueChanges$;
  }

  set(object: Collections[K]): Promise<BackendResponse> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref => this.storeBackend.set(ref, ref.path.ids[0], object)),
      )
      .toPromise();
  }

  update(object: Partial<Collections[K]>): Promise<BackendResponse> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref =>
          this.storeBackend.update(ref, ref.path.ids[0], object),
        ),
      )
      .toPromise();
  }

  remove(): Promise<BackendResponse> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref => this.storeBackend.delete(ref, ref.path.ids[0])),
      )
      .toPromise();
  }
}
